import { BotonCopiar, Seccion, tieneTexto } from './comunes'

/* ===========================================================================
   Hashtag — para encontrar después las fotos que nadie subió aquí.
   =========================================================================== */

export function hayHashtag(hashtag: string): boolean {
  return tieneTexto(hashtag)
}

/** La pareja lo escribe con o sin almohadilla; se muestra siempre con ella. */
function conAlmohadilla(bruto: string): string {
  const texto = bruto.trim().replace(/\s+/g, '')
  return texto.startsWith('#') ? texto : `#${texto}`
}

export default function Hashtag({ hashtag }: { hashtag: string }) {
  const etiqueta = conAlmohadilla(hashtag)

  return (
    <Seccion id="hashtag" eyebrow="Hashtag" titulo="Etiqueta tus fotos" tono="tinta">
      <p className="leading-relaxed text-palo">
        Si subes algo a tus redes ese día, usa esta etiqueta y lo encontramos todo junto.
      </p>
      {/* `break-words` y no `break-all`: parte solo si no cabe de otro modo, en
          vez de cortar «#VaneYLenin2026» a mitad de sílaba en un teléfono. */}
      <p className="mt-4 break-words font-mono text-3xl text-laton-claro sm:text-4xl">{etiqueta}</p>
      <BotonCopiar texto={etiqueta} etiqueta="Copiar el hashtag" sobreOscuro className="mt-4" />
    </Seccion>
  )
}
